import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    bulkAssignUsersApi,
    fetchAssignableUsersApi,
    fetchAssignedUsersByEventApi,
    fetchAssignedUsersByModuleApi,
    removeAssignmentApi,
} from "../../services/assignmentsApi";
import {
    bulkAssignUsersFail,
    bulkAssignUsersSuccess,
    fetchAssignableUsersFail,
    fetchAssignableUsersSuccess,
    fetchAssignedUsersByEventFail,
    fetchAssignedUsersByEventRequest,
    fetchAssignedUsersByEventSuccess,
    fetchAssignedUsersByModuleFail,
    fetchAssignedUsersByModuleRequest,
    fetchAssignedUsersByModuleSuccess,
    removeAssignmentFail,
    removeAssignmentSuccess,
    setAssignmentsLoading,
    setAssignmentsRemoving,
    setAssignmentsSubmitting,
} from "../actions/assignmentActions";

const getContextKey = ({ assignmentType, eventId, moduleId }) =>
    `${assignmentType || "UNKNOWN"}:${eventId || moduleId || "NONE"}`;

export function* fetchAssignableUsersSaga() {
    yield put(setAssignmentsLoading(true));
    try {
        const response = yield call(fetchAssignableUsersApi);
        yield put(fetchAssignableUsersSuccess(response.data));
    } catch (error) {
        yield put(fetchAssignableUsersFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setAssignmentsLoading(false));
    }
}

export function* fetchAssignedUsersByEventSaga(action) {
    yield put(setAssignmentsLoading(true));
    try {
        const response = yield call(fetchAssignedUsersByEventApi, action.payload.eventId);
        yield put(fetchAssignedUsersByEventSuccess(action.payload.eventId, response.data));
    } catch (error) {
        yield put(fetchAssignedUsersByEventFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setAssignmentsLoading(false));
    }
}

export function* fetchAssignedUsersByModuleSaga(action) {
    yield put(setAssignmentsLoading(true));
    try {
        const response = yield call(fetchAssignedUsersByModuleApi, action.payload.moduleId);
        yield put(fetchAssignedUsersByModuleSuccess(action.payload.moduleId, response.data));
    } catch (error) {
        yield put(fetchAssignedUsersByModuleFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setAssignmentsLoading(false));
    }
}

export function* bulkAssignUsersSaga(action) {
    yield put(setAssignmentsSubmitting(true));
    try {
        const response = yield call(bulkAssignUsersApi, action.payload);
        const contextKey = getContextKey(action.payload);
        yield put(bulkAssignUsersSuccess(response.data, contextKey));

        if (action.payload.assignmentType === "EVENT") {
            yield put(fetchAssignedUsersByEventRequest(action.payload.eventId));
        } else {
            yield put(fetchAssignedUsersByModuleRequest(action.payload.moduleId));
        }

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Affectation terminée",
            text: response.data?.message || "Affectation effectuée avec succès",
            timer: 2200,
            showConfirmButton: false,
        });
    } catch (error) {
        const message = error.response?.data?.message || error.message || "Erreur d'affectation";
        yield put(bulkAssignUsersFail(message));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: message,
            timer: 2500,
            showConfirmButton: false,
        });
    } finally {
        yield put(setAssignmentsSubmitting(false));
    }
}

export function* removeAssignmentSaga(action) {
    yield put(setAssignmentsRemoving(true));
    try {
        yield call(removeAssignmentApi, action.payload.assignmentId);
        yield put(removeAssignmentSuccess(action.payload.assignmentId));

        if (action.payload.context?.assignmentType === "EVENT") {
            yield put(fetchAssignedUsersByEventRequest(action.payload.context.targetId));
        } else if (action.payload.context?.assignmentType === "MODULE") {
            yield put(fetchAssignedUsersByModuleRequest(action.payload.context.targetId));
        }

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Affectation supprimée",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        const message = error.response?.data?.message || error.message || "Erreur de suppression";
        yield put(removeAssignmentFail(message));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: message,
            timer: 2500,
            showConfirmButton: false,
        });
    } finally {
        yield put(setAssignmentsRemoving(false));
    }
}
